import PageSEO from '@/components/base/PageSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import TestimonialSection from './components/TestimonialSection';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '911吃瓜网',
    url: 'http://51cgwang.cn/',
    description: '911吃瓜网官方入口，聚合911吃瓜爆料、911黑料吃瓜等热门黑料内容。每日实时追踪网红塌房、明星八卦、社会奇闻，独家爆料不断更新，吃瓜群众的第一手资源站。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://51cgwang.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '911吃瓜网',
    url: 'http://51cgwang.cn/',
    description: '国内领先的网红娱乐资讯聚合平台',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@51cgwang.cn',
    },
  };

  return (
    <>
      <PageSEO
        title="911吃瓜网 | 911吃瓜爆料与911黑料吃瓜 | 911吃瓜网官网入口网红黑料实时追踪"
        description="911吃瓜网官方入口，聚合911吃瓜爆料、911黑料吃瓜等热门黑料内容。每日实时追踪网红塌房、明星八卦、社会奇闻，独家爆料不断更新，吃瓜群众的第一手资源站。"
        keywords="911吃瓜网,911吃瓜爆料,911黑料吃瓜,911吃瓜网官网,911吃瓜网入口,网红黑料,实时爆料,吃瓜爆料,911爆料吃瓜,911吃瓜网站"
        canonicalUrl="http://51cgwang.cn/"
      />
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(orgSchema)}
      </script>

      <Navbar />
      <main>
        <HeroBanner />
        <CategoryGrid />
        <HotArticles />
        <CTASection />
        <TestimonialSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}